import React from 'react';

export default ({ color = '#C4C6CD' }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="7.25" stroke={color} strokeWidth="1.5" />
    <rect x="6" y="9" width="8" height="1.5" rx="0.75" fill={color} />
  </svg>
);
